import { useContext } from 'react';

import { LbOptionsContext } from '../model/store';

export const useOptions = () => useContext(LbOptionsContext);
